module.exports = __webpack_public_path__ + "img/40_69_002_340.dd75354c.jpg";